// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBBde8l876QdjUz0jTNB3znM9o77toXahQ",
  authDomain: "stevebrains-37aeb.firebaseapp.com",
  projectId: "stevebrains-37aeb",
  storageBucket: "stevebrains-37aeb.appspot.com",
  messagingSenderId: "809027443902",
  appId: "1:809027443902:web:9da7ed59017bdd229752ef",
};

// Initialize Firebase
export const fireBaseApp = initializeApp(firebaseConfig);
